import React from "react";
import CryptoJS from "crypto-js";
import moment from 'moment';
import Swal from 'sweetalert2'
import secureLocalStorage from "react-secure-storage";
import { VALIDATION_MESSAGE } from "../Constants/Constants";
import { adjustScheduledDateForDST } from "./DateTimeHelper";
import { DATETIME } from "../Constants/DateTimeConstant";
// import * as momentTZ from 'moment';


// import dateFormat from 'dateformat';
// ====Start encode & decode=====
const secretKey4 = 'O@RcQfTjWnZr4-PaiOwnER-KaNdRgUkX';
const secretKey5 = 'O@RcQChillINg-PaiOwnER-KaNdRgUkX';
const DefaultUser = require('../assets/images/user-default.png')


export const encodeID = (id: any) => {
  if (id != null) {
    const encryptedData4 = CryptoJS.AES.encrypt(id.toString(), secretKey4).toString();
    const encryptedDataMain: any = CryptoJS.AES.encrypt(encryptedData4.toString(), secretKey5).toString();
    return encryptedDataMain?.replaceAll("/", "Pai");
  } else {
    return id;
  }
}
export const decodeID = (id: any) => {
  if (id != null) {
    const replaceddata: any = id?.replaceAll("Pai", "/");
    const decryptedData = CryptoJS.AES.decrypt(replaceddata.toString(), secretKey5).toString(CryptoJS.enc.Utf8);
    const decryptedData1 = CryptoJS.AES.decrypt(decryptedData.toString(), secretKey4).toString(CryptoJS.enc.Utf8);
    return decryptedData1;
  } else {
    return id;
  }
}
// ====End encode & decode=====

export function isJson(str: any) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

// ===Start Select handlechange===
export const handleMultiSelectChange = (selectVal: any) => {
  const selectedValues = selectVal?.e ? selectVal?.e.map((d: any) => d.value) : [];
  selectVal?.setValueFunc(selectVal?.errorsKey, selectedValues);
  selectVal?.setSelectedFunc(selectVal?.e);
};
// ===End Select handlechange===

// ===Start Cache storage===
export const setCache = async (key: string, value: any) => {
  const data = new Response(JSON.stringify(value));
  if ("caches" in window) {
    const cache = await caches.open(key);
    cache.put(key, data);
  }
};

export const setDateFormat = (date: any) => {
  let formatDate = '';
  // if (date) {
  //   formatDate = moment(date).format('YYYY-MM-DD')
  // }
  if (date && moment(date, 'YYYY-MM-DD', true).isValid()) {
    formatDate = moment(date).format('YYYY-MM-DD'); 
  }
  return formatDate;
}

export const getDateFormat = (date: any) => {
  let formatDate = '';
  console.log("date is : ", date)
  // if (date) {
  //   formatDate = moment(date).format('YYYY-MM-DD')
  // }
  // if (date && moment(date, 'YYYY-MM-DD', true).isValid()) {
  if (date && moment(date).isValid()) {
    formatDate = moment(date).format('YYYY-MM-DD');
  }
  return formatDate;
}

export const getDateFormatData = (date: any) => {
  let formatDate;
  formatDate = moment(date).format('MM/DD/YYYY')
  // formatDate = moment(date).toDate();
  return formatDate;
}


export const handleShowSwalConfirmation = (msg: any = null, showCancel = false, showTitle = true) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: showTitle ? VALIDATION_MESSAGE?.ARE_YOU_SURE : "",
      text: msg ? msg : "Please complete all steps to proceed.",
      icon: 'warning',
      showDenyButton: showCancel,
      confirmButtonColor: '#31CE36',
      confirmButtonText: showCancel ? 'Yes' : 'Ok',
      allowOutsideClick: false,
      // closeable: true
    }).then((result) => {
      resolve(result.isConfirmed);
    });
  });

}


export const handleShowSwalConfirmationOk = (msg: any = null, showCancel = false) => {


  return new Promise((resolve) => {
    Swal.fire({
      title: showCancel ? VALIDATION_MESSAGE?.ARE_YOU_SURE : "",
      text: msg ? msg : "Please complete all steps to proceed.",
      icon: 'warning',
      showDenyButton: showCancel,
      // showCancelButton: showCancel,
      confirmButtonColor: '#31CE36',
      cancelButtonColor: '#d33',
      denyButtonText: 'No',
      confirmButtonText: 'Yes',
      allowOutsideClick: false,

    }).then((result) => {
      resolve(result.isConfirmed);
    });


  });

}


export const handleShowSwalConfirmationCancel = (msg: any = null, showCancel = false, showTitle = true) => {
  return new Promise((resolve) => {
    Swal.fire({
      title: showTitle ? VALIDATION_MESSAGE?.ARE_YOU_SURE : "",
      text: msg ? msg : "Please complete all steps to proceed.",
      icon: 'warning',
      showDenyButton: showCancel,
      confirmButtonColor: '#31CE36',
      confirmButtonText: showCancel ? 'Ok' : 'Ok',
      allowOutsideClick: false,
      denyButtonText: 'Cancel',
    }).then((result) => {
      resolve(result.isConfirmed);
    });
  });

}

export const getCache = async (key: string, setData: any) => {
  if (typeof caches === "undefined") return false;
  const cacheStorage = await caches.open(key);
  const cachedResponse = await cacheStorage.match(key);
  if (!cachedResponse || !cachedResponse.ok) {
    setData("Fetch failed!");
    return null;
  }
  return cachedResponse.json().then((item: any) => {
    setData(item);
  });
};
// ===End Cache storage===

// ===Start Image Icon Show=== 
export const ImageUrl = (icon: any) => {
  return icon
}
// ===End Image Icon Show=== 

// Form data using image upload
export const renderFormData = (values: any) => {
  var formData = new FormData();
  Object.keys(values).map(function (key) {
    formData.append(key, values[key])
  });
  return formData
}

// Default image use if no image 
export const userPicUrl = (url: any) => {
  const PUrl = url ? url : DefaultUser;
  return PUrl;
}

// Name and Last name show
export const FullName = (fname: any, lname: any) => {
  let HFname = fname ? fname : '';
  let HLname = lname ? lname : '';
  return HFname + " " + HLname
}

// Country code  + Number
export const FullPhoneNUmber = (phone_country_code: any, phone_number: any) => {
  let Hpcc = phone_country_code ? '+' + phone_country_code + ' ' : '';
  let Hpn = phone_number ? phone_number : '';
  return Hpcc + Hpn
}

// Last Url location 
export const getLastURL = (location: any) => {
  let lastURL = location && location.pathname && location.pathname.split('/') && location.pathname.split('/').pop();
  return lastURL;
}

export const getDate = (date = null) => {
  const formattedDate = date ? moment(new Date(date)).format('MMMM DD, YYYY') : '';
  return formattedDate;
}
export const getDateTime = (date: string) => {
  const formattedDate = date ? moment(new Date(date)).format('MMMM DD, YYYY  ') : '';
  return formattedDate;
}

//  date utc  formate
// export const getUtcDateTime = (date: string) => {
//   const formattedDate = moment((date)).utc().format('DD, MMMM, YYYY H:mm');
//   return formattedDate;
// }


export const getUtcDateTime = (date: string) => {
  const formattedDate = adjustScheduledDateForDST(date,DATETIME?.DEFAULT_DATETIME)
  //moment.utc(date).format('MMMM DD, YYYY h:mm A');
  return formattedDate;
}


export const formatDate = (isoDate: any) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  // return `${year}-${month}-${day}`;
  return `${month}-${day}-${year}`;
}


export const formatMonth = (isoDate: any) => {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  return `${month}-${day}-${year}`;
}


export const setItemToStorage = (key: any, value: any) => {
  secureLocalStorage.setItem(key, JSON.stringify((value)));
}

export const getItemFromStorage = (key: any) => {
  const val: any = secureLocalStorage.getItem(key);
  return isJson(val)? JSON.parse(val):"";
}

export const removeItemFromStorage = (key: any) => {
  return secureLocalStorage.removeItem(key);
}

export const clearStorage = () => {
  secureLocalStorage.clear();
}

export const getObjectKeyByValue = (object: any, value: any) => {
  return Object.keys(object).filter(key =>
    object[key] === value);
}

export const getSearchQueryParams = (location: any, key: any) => {
  const searchParams = new URLSearchParams(location.search);
  const value = searchParams.get(key);
  return value;
}


export const getCurrentDate = () => {
  // const today = new Date();
  // const year = today.getFullYear();
  // const month = String(today.getMonth() + 1).padStart(2, '0');
  // const day = String(today.getDate()).padStart(2, '0');

  // return `${year}-${month}-${day}`;
  // return moment()
  return moment().format('YYYY-MM-DD');
}

export const getMoneyHelper = (amount: any) => {
  return `${amount ? '$' + amount : ""}`
}
// country code dropdown

export const DefaultEditorButtons = [
  // 'source', '|',
  'bold',
  // 'strikethrough',
  'underline',
  'italic', '|',
  'ul',
  'ol', '|',
  'outdent', 'indent', '|',
  'font',
  'fontsize',
  // 'brush',
  // 'paragraph', '|',
  // 'table',
  // 'link', '|',
  'align', 'undo', 'redo', '|',
  'hr',
  // 'eraser',
  // 'copyformat', '|',
  // 'symbol',
  'fullsize',
  // 'print',
  // 'paste'
]

export const countryCodeValue = ["af",
  "ax",
  "al",
  "dz",
  "as",
  "ad",
  "ao",
  "ai",
  "aq",
  "ag",
  "ar",
  "am",
  "aw",
  "au",
  "at",
  "az",
  "bh",
  "bs",
  "bd",
  "bb",
  "by",
  "be",
  "bz",
  "bj",
  "bm",
  "bt",
  "bo",
  "bq",
  "ba",
  "bw",
  "bv",
  "br",
  "io",
  "bn",
  "bg",
  "bf",
  "bi",
  "kh",
  "cm",
  "ca",
  "cv",
  "ky",
  "cf",
  "td",
  "cl",
  "cn",
  "cx",
  "cc",
  "co",
  "km",
  "cg",
  "cd",
  "ck",
  "cr",
  "ci",
  "hr",
  "cu",
  "cw",
  "cy",
  "cz",
  "dk",
  "dj",
  "dm",
  "do",
  "ec",
  "eg",
  "sv",
  "gq",
  "er",
  "ee",
  "et",
  "fk",
  "fo",
  "fj",
  "fi",
  "fr",
  "gf",
  "pf",
  "tf",
  "ga",
  "gm",
  "ge",
  "de",
  "gh",
  "gi",
  "gr",
  "gl",
  "gd",
  "gp",
  "gu",
  "gt",
  "gg",
  "gn",
  "gw",
  "gy",
  "ht",
  "hm",
  "va",
  "hn",
  "hk",
  "hu",
  "is",
  "in",
  "id",
  "ir",
  "iq",
  "ie",
  "im",
  "il",
  "it",
  "jm",
  "jp",
  "je",
  "jo",
  "kz",
  "ke",
  "ki",
  "kp",
  "kr",
  "kw",
  "kg",
  "la",
  "lv",
  "lb",
  "ls",
  "lr",
  "ly",
  "li",
  "lt",
  "lu",
  "mo",
  "mk",
  "mg",
  "mw",
  "my",
  "mv",
  "ml",
  "mt",
  "mh",
  "mq",
  "mr",
  "mu",
  "yt",
  "mx",
  "fm",
  "md",
  "mc",
  "mn",
  "me",
  "ms",
  "ma",
  "mz",
  "mm",
  "na",
  "nr",
  "np",
  "nl",
  "nc",
  "nz",
  "ni",
  "ne",
  "ng",
  "nu",
  "nf",
  "mp",
  "no",
  "om",
  "pk",
  "pw",
  "ps",
  "pa",
  "pg",
  "py",
  "pe",
  "ph",
  "pn",
  "pl",
  "pt",
  "pr",
  "qa",
  "re",
  "ro",
  "ru",
  "rw",
  "bl",
  "sh",
  "kn",
  "lc",
  "mf",
  "pm",
  "vc",
  "ws",
  "sm",
  "st",
  "sa",
  "sn",
  "rs",
  "sc",
  "sl",
  "sg",
  "sx",
  "sk",
  "si",
  "sb",
  "so",
  "za",
  "gs",
  "ss",
  "es",
  "lk",
  "sd",
  "sr",
  "sj",
  "sz",
  "se",
  "ch",
  "sy",
  "tw",
  "tj",
  "tz",
  "th",
  "tl",
  "tg",
  "tk",
  "to",
  "tt",
  "tn",
  "tr",
  "tm",
  "tc",
  "tv",
  "ug",
  "ua",
  "ae",
  "gb",
  "us",
  "um",
  "uy",
  "uz",
  "vu",
  "ve",
  "vn",
  "vg",
  "vi",
  "wf",
  "eh",
  "ye",
  "zm",
  "zw"];


export const replaceToString = (str: any) => {
  if (str === null || str === '') {
    return false;
  } else {
    str = str.toString();
    const replacedString = str.replace(/<[^>]+>|&nbsp;/g, "");

    return replacedString;
  }
};

export const imageExtentionSupport = ["jpeg", "jpg", "png", "webp", "PNG", "JPG", "JPEG", "WEBP"];

export const getYear = () => {
  const minDate = new Date(2023, 0, 2).toISOString().split('T')[0];
  return minDate;
}

export const calculateMinAfterDate = (date: any) => {

  if (!date) {
    return '';
  } else {
    const result = new Date(date);
    result.setDate(result.getDate() + 1);

    // Check if the date is invalid
    if (isNaN(result.getTime())) {
      return ''; // or handle this case as needed in your application
    }

    return result.toISOString().split('T')[0];
  }
};






export const manualValidateForm = async ({ formSchema, errors, getValues, setError }: any) => {
  return new Promise((resolve, reject) => {
    formSchema.validate(getValues(), { abortEarly: false })
      .then(() => {
        Object.keys(errors).forEach((field) => {
          setError(field, {
            type: 'manual',
            message: '',
          });
        });
        resolve(true);
      })
      .catch((error: any) => {
        error.inner.forEach((err: any) => {
          setError(err.path, {
            type: 'manual',
            message: err.message,
          });
        });
        Object.keys(getValues()).forEach((field) => {
          if (!error.inner.find((err: any) => err.path === field)) {
            setError(field, {
              type: 'manual',
              message: '',
            });
          }
        });
        resolve(false);
      });
  });
};

export const mergeDateTime = (dateString: any, timeString: any) => {
  var mergedDateTimeString = dateString + " " + timeString;

  return mergedDateTimeString;
}


export const formatDateTime = (dateString: any) => {
  // Parse the original date string using Moment.js and specify UTC time zone
  const parsedDate = moment.utc(dateString);

  // Format the date as "YYYY-MM-DD" (2024-12-10)
  const formattedDate = parsedDate.format("YYYY-MM-DD");

  // Format the time as "HH:mm" (16:12) in local time zone
  const formattedTime = parsedDate.format("HH:mm");

  return { formattedTime, formattedDate };

}

export const addDay = (date: any, days: any) => {
  var result = new Date(date);
  let formatDate;
  let newData = result.setDate(result.getDate() + days);
  formatDate = moment(newData).format('YYYY-MM-DD')
  return formatDate;

  return result;
}


export const addDays = (date: any, days: any) => {
  var result = new Date(date);
  let formatDate;
  result.setDate(result.getDate() + days);

  return result;
}

export const StringSplitHelper = (text: any, limit: any = 15) => {
  let shortenedText = ""
  if (text) {
    shortenedText = `${text.substring(0, limit)}${text?.length > limit ? '...' : ""}`;
  }
  return shortenedText;
}
export const isEmpty = (value: any) => {
  return Boolean(value)
}


export const formatOrderDateTimeRange = (date: string, start: string, end: string, timezone: string): string => {

  const formattedDate = moment(date).format('DD/MM/YY');
  const startTime = moment.utc(start, 'HH:mm:ss').format('h A');
  const endTime = moment.utc(end, 'HH:mm:ss').format('h A');

  return `${formattedDate} | ${startTime} - ${endTime}`;

};

export const renderFormDataMultiple = (values: any, images: any[]) => {
  var formData = new FormData();
  Object.keys(values).forEach(function (key) {
    if (key === "image_file") {
      images.forEach((image, index) => {
        formData.append(`image_file`, image);
      });
    } else {
      formData.append(key, values[key]);
    }
  });
  return formData;
};


export const getLocalTime = (time: any,) => {
  const localDate = moment.utc(time).local().format('YYYY-MM-DD HH:mm:ss');
  const localTime = moment.utc(time).local().format('h:mm:ss A');
  return { localTime, localDate };
};


//dev sd


export const getDateTimeFormat = (dTime: any, format: any = 24) => {
  let formatDateTime = '';
  let momentFormat = 'YYYY-MM-DD';
  if (dTime) {
    if (format === 12) {
      momentFormat += ' hh:mm A';
    } else if (format === 24) {
      momentFormat += ' HH:mm';
    }
    formatDateTime = moment((dTime)).utc().format(momentFormat)
  }
  return formatDateTime;
};



export const WeekDayFormat = (data: any) => {
  if(data != undefined){

    const daysArray = JSON.parse(data);
    const weekdayOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const sortByWeekday = (a: any, b: any) => {
      return weekdayOrder.indexOf(a.day) - weekdayOrder.indexOf(b.day);
    };
    daysArray.sort(sortByWeekday);
    return daysArray.map((dayData: any) => ({
      day: dayData.day,
      start_time:moment.utc(dayData.start_time, "HH:mm:ss").local().format("HH:mm:ss")      ,
      end_time: moment.utc(dayData.end_time, "HH:mm:ss").local().format("HH:mm:ss")

    }));
  }else{
    return []
  }
};

export const TimeDisplay = (time: any) => {
  const formattedTime = time?.slice(0, 5);
  return <span>{formattedTime}</span>;
};


export const getStatus = (status :any) => {
  // console.log(typeof(status))
  switch (status) {
      case 0:
          return <p>Upcoming</p>;
      case 1:
          return <p>Completed</p>;
      case 2:
          return <p>Cancelled</p>;
      case 3:
          return <p>No shown up</p>; // No text for "No Show"
      default:
          return 'No Status';
  }
};

// get Browser Timezone
export const getBrowserTimezone = () : string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone;
};

// convert To USA Time
export const convertToBrowserTime = (date: string): string => {
  const timeZone = getBrowserTimezone();
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone,
  };
  
  // Parse the input date
  const parsedDate = new Date(date);

  // Subtract 5 hours (5 * 60 * 60 * 1000 milliseconds)
  const adjustedDate = new Date(parsedDate.getTime() - 5 * 60 * 60 * 1000);

  // Format the adjusted date
  return new Intl.DateTimeFormat('en-US', options).format(adjustedDate);
};
